import { mergeClasses } from "@huub-web/utils";
import type { FC } from "react";
import { motion } from "motion/react";

import { errorContainer } from "./FormInputError.css";
import { Text } from "../Text/Text";
import { Tooltip, type TooltipProps } from "../Tooltip/Tooltip";

export type FormInputErrorProps = {
  message?: string;
  floating?: boolean;
  targetRef?: TooltipProps["targetRef"];
  placement?: TooltipProps["placement"];
};

/**
 * A component that displays an error message for a form input field.
 */
export const FormInputError: FC<FormInputErrorProps> = ({
  message,
  placement,
  targetRef,
  floating = false,
}) => {
  if (!message) {
    return null;
  }

  return floating ? (
    <Tooltip
      targetRef={targetRef}
      value={message}
      placement={placement}
      active
      variant="error"
    />
  ) : (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: "auto", opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <Text
        as="p"
        className={mergeClasses(errorContainer)}
        role="alert"
        variant="bodyS"
      >
        {message}
      </Text>
    </motion.div>
  );
};
